export const messages = {
  fr: {
    pageTitle: {
      settings: 'Paramètres',
    },
    homePageLoading: 'Chargement de la page d\'accueil...',
    dataFrom: 'Les contenus de l`application :',
    available: 'sont disponibles uniquement sur le site suivant : ',
    needGeolocation: 'Afin de pouvoir accéder à l\'application, vous devez être géolocalisé.',
    enableGeolocation: 'Activer la géolocalisation',
    thankToAccept: 'Merci d\'accepter la demande d\'autorisation faite par votre navigateur afin que cette application puisse accèder à vos données GPS',
    locationLoading: 'Localisation en cours...',
    geolocationDisabled: 'Humm... La géolocalisation ne semble pas autorisé par votre navigateur.',
    authorizedBlockGeolocation: 'Merci de modifier les droits d\'accès aux données de géolocalisation pour l\'application sur ce navigateur.',
    wrongLocation: 'Vous n\'avez pas accès hors site.',
    geolocationNotAvailable: 'Votre navigateur ne prend pas en charge la géolocalisation',
    language: {
      selectedLanguage: 'Langue d\'utilisation',
      selectedTarget: 'Spécialisation / Mode de lecture',
      standard: 'Standard',
      childMode: 'Niveau enfant',
      signLanguage: 'Langue des signes'
    },
    accessibility: {
      title: 'Accessibilité',
      textSize: 'Taille du texte',
      wordSpacing: 'Espacement des mots',
      greyScale: 'Niveau de gris',
      dyslexicFont: 'Police dyslexique',
      highContrast: 'Contraste élevé',
      textToSpeech: 'Lecture voix haute'
    },
    configuration: {
      welcome: '👋 Bienvenue !',
      start: 'Valider',
      skip: 'Passer',
      next: 'Suivant',
      title: 'Configuration',
      subtitle: `Pour que votre visite soit la plus confortable possible :`,
      languageStep: '1️⃣ Sélectionnez votre langue',
      accessibilityStep: '2️⃣ Ajustez l\'accessibilité',
      offlineStep: '3️⃣ Précharger les données',
      offlineTitle: '3️⃣ Données préchargées',
      offlineText: 'Afin que l\'application puisse fonctionner, vous devez précharger les données.',
      congratulation: '👍 Félicitations !',
      congratulationText: 'Votre visite est prête.<br><br>Modifiez vos préférences à tout moment dans les paramètres de l\'application.',
      congratulationEnd: 'Bonne découverte !',
    },
    game: {
      memory: {
        memory: 'Jeu de mémoire',
        start: 'Jouer',
        restart: 'Rejouer',
        congrats: 'Félicitations'
      },
      timeline: {
        timeline: 'Frise Chronologique',
        start: 'Jouer',
        info: 'en savoir plus',
        restart: 'Refaire la frise chronologique',
        congrats: 'Félicitations ! <br>Toutes les images sont à leur place.',
        error: 'Humm... il y a des erreurs.',
        showTimeline: 'Voir le resultat',
        showInformation: 'Revoir les félicitations'
      }
    },
    enterTiketNumber: 'Numéro de billet Audioguide',
    validate: 'Valider mon billet',
    buyTicket: 'Acheter un billet',
    ticketAvailableOn: 'Date limite de validité : ',
    lockText: 'Un billet audioguide est nécessaire pour accéder à ce contenu',
    unLock: 'Déverrouiller',
    ticketStatus: {
      tooEarly: 'Votre Billet n\'est pas encore valide',
      tooLate: 'Votre Billet n\'est plus valide ',
      alreadyUsedByAnother: 'Ce billet est en cours d\'utilisation sur un autre appareil',
      alreadyUsedByMany: 'Le nombre d\'utilisation maximale de ce billet pour votre groupe est atteint.',
      none: 'Vous n\'avez aucun billet enregistré',
      pending: 'Demande de validation en attente',
      notExist: 'Ce billet n\'existe pas.',
      invalidDate: 'Votre billet n\'est actuellement pas valide',
      alreadyUsed: 'Votre billet est déjà utilisé',
      valid: 'Votre billet est valide',
      error: 'Un erreur est survenu avec ce billet'
    },
    content: {
      textContent: {
        readMore: 'Lire la suite'
      },
      person: {
        readBiography: 'Lire la biographie'
      }
    },
    preloadStatus: {
      reloadTitle: 'Actualisation',
      reloadText: 'L\'application doit d\être actualisée afin d\'activer certaines fonctionnalités.',
      reloadQuestion: 'Acceptez-vous d\'actualiser maintenant l\'application ?',
      yes: 'Oui',
      no: 'Non',
      preloadModalTitle: 'Téléchargement des contenus',
      preloadModalText: {
        introduction: 'Avant de commencer la visite, nous devons télécharger les contenus suivants :',
        downloading: 'Téléchargement en cours ...',
        downloaded: 'Félicitations, les contenus sont téléchargés !',
        error: 'Un erreur est survene lors du téléchargement.',
        translatedTexts: 'Les textes en ',
        images: 'Les images',
        translatedAudios: 'Les pistes audios en ',
        iconInstruction: 'Vous pouvez suivre l\'avancement du chargement des contenus en cliquant sur l\'icône ci-dessous, situé à côté du bouton menu de l\'application :',
        end: 'Une notification vous informera de la fin du chargement des contenus. Vous pouvez utiliser l\'application pendant ce temps.',
        startPreload: 'Télécharger',
        rejectPreload: 'Annuler',
        close: 'Fermer'
      },
      preloadStatusText: 'Status de pré-chargenent des contenus :',
      preloadStatusEnded: 'Vous pouvez à présent utiliser l\'application hors ligne.',
      off: 'Désactivé',
      apiDataPreloading: 'Préchargement des textes...',
      apiDataPreloaded: 'Préchargement des textes... OK',
      filesPreloading: 'Préchargement des fichiers...',
      filesPreloaded: 'Préchargement des fichiers... OK',
      done: 'Terminé'
    },
    mediaSync: {
      title: 'Ecoute en direct',
      openPlayer: 'Ecouter',
      contentTitle: 'Vidéo en direct :',
      status: {
        live: 'En direct',
        offline: 'Hors ligne'
      }
    }
  },
  en: {
    pageTitle: {
      settings: 'Settings',
    },
    homePageLoading: 'Home page loading...',
    dataFrom: 'The contents of the application:',
    available: 'are available only on the following site: ',
    needGeolocation: 'In order to access the application, you must be geolocated.',
    enableGeolocation: 'Activate geolocation',
    thankToAccept: 'Please accept the authorization request made by your browser so that this application can access your GPS data',
    locationLoading: 'Location in progress...',
    geolocationDisabled: 'Hmmm... Geolocation does not seem to be allowed by your browser.',
    authorizedBlockGeolocation: 'Please modify the access rights to the geolocation data for the application on this browser.',
    wrongLocation: 'You do not have off-site access.',
    geolocationNotAvailable: 'Your browser does not support geolocation',
    game: {
      memory: {
        memory: 'Memory game',
        start: 'Start',
        restart: 'Restart',
        congrats: 'Congratulation'
      },
      timeline: {
        timeline: 'Timeline',
        start: 'Play',
        info: 'more information',
        restart: 'Make again',
        congrats: 'Congratulation! <br>All images are in the right place. ',
        error: 'Humm... there are errors.',
        showTimeline: 'Show completed timeline',
        showInformation: 'Show congratulations'
      }
    },
    enterTiketNumber: 'Audioguide ticket number',
    validate: 'Validate my ticket',
    buyTicket: 'Buy a ticket',
    ticketAvailableOn: 'Expiration date: ',
    lockText: 'Valid audioguide ticket is required to access this content',
    unLock: 'Unlock',
    ticketStatus: {
      tooEarly: 'Your ticket is not valid yet',
      tooLate: 'Your ticket is no longer valid',
      alreadyUsedByAnother: 'This ticket is being used on another device',
      alreadyUsedByMany: 'The maximum number of uses of this ticket for your group has been reached',
      none: 'You do not have any registered tickets',
      pending: 'Pending validation request',
      notExist: 'This ticket does not exist.',
      invalidDate: 'Your ticket is currently not valid',
      alreadyUsed: 'Your ticket is already used',
      valid: 'Your ticket is valid',
      error: 'An error occurred with this post'
    },
    content: {
      textContent: {
        readMore: 'Read more'
      },
      person: {
        readBiography: 'Read biography'
      }
    },
    language: {
      selectedLanguage: 'Language',
      selectedTarget: 'Specialization / Reading mode',
      standard: 'Standard',
      childMode: 'Child level',
      signLanguage: 'Sign language'
    },
    accessibility: {
      title: 'Accessibility',
      textSize: 'Text size',
      wordSpacing: 'Word spacing',
      greyScale: ' Grey scale',
      dyslexicFont: 'Dyslexic font',
      highContrast: 'High contrast',
      textToSpeech: 'Text to Speech',
    },
    configuration: {
      welcome: '👋 Welcome',
      selectedLanguage: 'Selected language',
      selectedTarget: 'Reading mode',
      start: 'Start',
      standard: 'Standard',
      childMode: 'Child Level',
      signLanguage: 'Sign language',
      skip: 'Skip',
      next: 'Next',
      title: 'Configuration',
      subtitle: `In order to have the best possible experience:`,
      languageStep: '1️⃣ Select your language',
      accessibilityStep: '2️⃣ Adjust the accessibility',
      congratulation: '👍 Congratulations!',
      congratulationText: 'Your visit is ready.<br><br>Modify your preferences at any time in the application settings. ',
      congratulationEnd: 'Enjoy your visit!',
    },
    preloadStatus: {
      reloadTitle: 'Update',
      reloadText: 'The application needs to be updated to enable certain features.',
      reloadQuestion: 'Do you agree to update the application now?',
      yes: 'Yes',
      no: 'No',
      preloadModalTitle: 'Downloading content',
      preloadModalText: {
        introduction: 'Before starting the tour, we must download the following contents:',
        downloading: 'Download in progress ...',
        downloaded: 'Congratulations, the contents are downloaded!',
        error: 'An error occurred during the download.',
        translatedTexts: 'The texts in ',
        images: 'The images',
        translatedAudios: 'The audio tracks in ',
        iconInstruction: 'You can follow the progress of the content loading by clicking on the icon below, located next to the application\'s menu button :',
        end: 'A notification will inform you when the content is finished loading. You can use the application during this time.',
        startPreload: 'Dowload',
        rejectPreload: 'Cancel',
        close: 'Close'
      },
      preloadStatusText: 'Pre-loading status of the contents:',
      preloadStatusEnded: 'You can now use the application offline.',
      off: 'Off',
      apiDataPreloading: 'Preloading of texts...',
      apiDataPreloaded: 'Preloading texts... OK',
      filesPreloading: 'Preloading files...',
      filesPreloaded: 'Preloading of files... OK',
      done: 'Completed'
    },
    mediaSync: {
      title: 'Listening live'
    }
  },
  de: {
    homePageLoading: 'Startseite wird geladen...',
    dataFrom: 'Die Inhalte der Anwendung:',
    available: 'sind nur auf der folgenden Website verfügbar: ',
    needGeolocation: 'Um auf die Anwendung zugreifen zu können, müssen Sie geortet werden.',
    enableGeolocation: 'Geolokalisierung aktivieren',
    thankToAccept: 'Bitte akzeptieren Sie die Autorisierungsanfrage Ihres Browsers, damit diese Anwendung auf Ihre GPS-Daten zugreifen kann',
    locationLoading: 'Standortbestimmung läuft...',
    geolocationDisabled: 'Hmm... Die Geolokalisierung scheint von Ihrem Browser nicht erlaubt zu sein.',
    authorizedBlockGeolocation: 'Bitte ändern Sie die Zugriffsrechte auf die Geolokalisierungsdaten für die Anwendung in diesem Browser.',
    wrongLocation: 'Sie haben keinen Zugriff außerhalb des Standorts.',
    geolocationNotAvailable: 'Ihr Browser unterstützt keine Geolokalisierung',
    enterTiketNumber: 'Audioguide-Ticketnummer',
    validate: 'Mein Ticket validieren',
    buyTicket: 'Ein Ticket kaufen',
    ticketAvailableOn: 'Verfallsdatum: ',
    lockText: 'Für den Zugriff auf diesen Inhalt ist ein Audioguide-Ticket erforderlich',
    unLock: 'freischalten',
    ticketStatus: {
      tooEarly: 'Ihr Ticket ist noch nicht gültig',
      tooLate: 'Ihr Ticket ist nicht mehr gültig',
      alreadyUsedByAnother: 'Dieses Ticket wird auf einem anderen Gerät verwendet',
      alreadyUsedByMany: 'Die maximale Anzahl der Nutzungen dieses Tickets für Ihre Gruppe wurde erreicht',
      none: 'Sie haben keine registrierten Tickets',
      pending: 'Anstehende Validierungsanfrage',
      notExist: 'Dieses Ticket existiert nicht.',
      invalidDate: 'Ihr Ticket ist derzeit nicht gültig',
      alreadyUsed: 'Ihr Ticket ist bereits verwendet',
      valid: 'Ihr Ticket ist gültig',
      error: 'Bei diesem Beitrag ist ein Fehler aufgetreten'
    },
    content: {
      textContent: {
        readMore: 'Mehr lesen'
      },
      person: {
        readBiography: 'Biographie lesen'
      }
    },
    language: {
      selectedLanguage: 'Sprache',
      selectedTarget: 'Spezialisierung / Lesemodus',
      standard: 'Standard',
      childMode: 'Kinderstufe',
      signLanguage: 'Gebärdensprache'
    },
    accessibility: {
      title: 'Barrierefreiheit',
      textSize: 'Textgröße',
      wordSpacing: 'Wortabstand',
      greyScale: 'Graustufen',
      dyslexicFont: 'Legasthenie-Schrift',
      highContrast: 'Hoher Kontrast',
      textToSpeech: 'Text zu Sprache',
    },
    configuration: {
      welcome: '👋 Willkommen',
      selectedLanguage: 'Ausgewählte Sprache',
      selectedTarget: 'Lesemodus',
      start: 'Start',
      standard: 'Standard',
      childMode: 'Kinderstufe',
      signLanguage: 'Gebärdensprache',
      skip: 'Überspringen',
      next: 'Weiter',
      title: 'Konfiguration',
      subtitle: `Um die bestmögliche Erfahrung zu machen:`,
      languageStep: '1️⃣ Wählen Sie Ihre Sprache',
      accessibilityStep: '2️⃣ Anpassung der Barrierefreiheit',
      congratulation: '👍 Glückwunsch!',
      congratulationText: 'Ihr Besuch ist fertig.<br><br>Ändern Sie Ihre Einstellungen jederzeit in den Anwendungseinstellungen.',
      congratulationEnd: 'Viel Spaß bei Ihrem Besuch!',
    },
    preloadStatus: {
      reloadTitle: 'Aktualisierung',
      reloadText: 'Die Anwendung muss aktualisiert werden, um bestimmte Funktionen zu aktivieren.',
      reloadQuestion: 'Sind Sie damit einverstanden, die Anwendung jetzt zu aktualisieren?',
      yes: 'Ja',
      no: 'Nein',
      preloadModalTitle: 'Inhalt wird heruntergeladen',
      preloadModalText: {
        introduction: 'Bevor wir die Tour starten, müssen wir die folgenden Inhalte herunterladen:',
        downloading: 'Download läuft...',
        downloaded: 'Herzlichen Glückwunsch, die Inhalte sind heruntergeladen!',
        error: 'Während des Downloads ist ein Fehler aufgetreten.',
        translatedTexts: 'Die Texte in ',
        images: 'Die Bilder',
        translatedAudios: 'Die Audiospuren in ',
        iconInstruction: 'Sie können den Fortschritt des Ladevorgangs der Inhalte verfolgen, indem Sie auf das unten stehende Symbol neben der Menüschaltfläche der Anwendung klicken:',
        end: 'Eine Benachrichtigung informiert Sie, wenn das Laden der Inhalte abgeschlossen ist. Sie können die Anwendung während dieser Zeit nutzen.',
        startPreload: 'Herunterladen',
        rejectPreload: 'Abbrechen',
        close: 'Schließen'
      },
      preloadStatusText: 'Status des Vorladens der Inhalte:',
      preloadStatusEnded: 'Sie können die Anwendung jetzt offline nutzen.',
      off: 'Aus',
      apiDataPreloading: 'Vorladen von Texten...',
      apiDataPreloaded: 'Vorladen von Texten... OK',
      filesPreloading: 'Vorladen von Dateien...',
      filesPreloaded: 'Vorladen von Dateien... OK',
      done: 'Abgeschlossen'
    },
    mediaSync: {
      title: 'Live zuhören'
    }
  },
  nl: {
    homePageLoading: 'Startpagina laden...',
    dataFrom: 'De inhoud van de applicatie:',
    available: 'is alleen beschikbaar op de volgende site: ',
    needGeolocation: 'Om toegang te krijgen tot de applicatie moet u worden geolokaliseerd.',
    enableGeolocation: 'Geolocatie activeren',
    thankToAccept: 'Accepteer het autorisatieverzoek van uw browser zodat deze applicatie toegang heeft tot uw GPS-gegevens',
    locationLoading: 'Locatie wordt bepaald...',
    geolocationDisabled: 'Hmm... Geolocatie lijkt niet te zijn toegestaan door uw browser.',
    authorizedBlockGeolocation: 'Wijzig de toegangsrechten voor de geolocatiegegevens voor de applicatie in deze browser.',
    wrongLocation: 'U heeft geen toegang buiten de locatie.',
    geolocationNotAvailable: 'Uw browser ondersteunt geen geolocatie',
    enterTiketNumber: 'Audiogids ticketnummer',
    validate: 'Valideer mijn ticket',
    buyTicket: 'Koop een ticket',
    ticketAvailableOn: 'Vervaldatum: ',
    lockText: 'Een audioguide ticket is vereist om toegang te krijgen tot deze inhoud',
    unLock: 'Ontgrendelen',
    ticketStatus: {
      tooEarly: 'Uw ticket is nog niet geldig',
      tooLate: 'Uw ticket is niet langer geldig',
      alreadyUsedByAnother: 'Dit ticket wordt op een ander apparaat gebruikt',
      alreadyUsedByMany: 'Het maximale aantal keren dat uw groep dit ticket kan gebruiken is bereikt',
      none: 'U heeft geen geregistreerde tickets',
      pending: 'In afwachting van validatieverzoek',
      notExist: 'Dit ticket bestaat niet..',
      invalidDate: 'Uw ticket is momenteel niet geldig',
      alreadyUsed: 'Uw ticket is al gebruikt',
      valid: 'Uw ticket is geldig',
      error: 'Er is een fout opgetreden bij dit bericht'
    },
    constent: {
      textContent: {
        readMore: 'Lees meer'
      },
      person: {
        readBiography: 'Lees biografie'
      }
    },
    language: {
      selectedLanguage: 'Taal',
      selectedTarget: 'Specialisatie / Leeswijze',
      standard: 'Standaard',
      childMode: 'Kinderniveau',
      signLanguage: 'Gebarentaal'
    },
    accessibility: {
      title: 'Toegankelijkheid',
      textSize: 'Tekstgrootte',
      wordSpacing: 'Woordafstand',
      greyScale: 'Grijswaarden',
      dyslexicFont: 'Dyslexie lettertype',
      highContrast: 'Hoog contrast',
      textToSpeech: 'Tekst naar spraak',
    },
    configuration: {
      welcome: '👋 Welkom',
      selectedLanguage: 'Geselecteerde taal',
      selectedTarget: 'Leesmodus',
      start: 'Start',
      standard: 'Standaard',
      childMode: 'Kinderniveau',
      signLanguage: 'Gebarentaal',
      skip: 'Overslaan',
      next: 'Volgende',
      title: 'Configuratie',
      subtitle: `Om de best mogelijke ervaring te hebben:`,
      languageStep: '1️⃣ Selecteer uw taal',
      accessibilityStep: '2️⃣ Pas de toegankelijkheid aan',
      congratulation: '👍 Gefeliciteerd!',
      congratulationText: 'Uw bezoek is klaar.<br><br>Wijzig uw voorkeuren op elk moment in de applicatie-instellingen.',
      congratulationEnd: 'Geniet van uw bezoek!',
    },
    preloadStatus: {
      reloadTitle: 'Bijwerken',
      reloadText: 'De applicatie moet worden bijgewerkt om bepaalde functies in te schakelen.',
      reloadQuestion: 'Wilt u de applicatie nu bijwerken?',
      yes: 'Ja',
      no: 'Nee',
      preloadModalTitle: 'Inhoud wordt gedownload',
      preloadModalText: {
        introduction: 'Voordat we de tour starten, moeten we de volgende inhoud downloaden:',
        downloading: 'Download bezig...',
        downloaded: 'Gefeliciteerd, de inhoud is gedownload!',
        error: 'Er is een fout opgetreden tijdens het downloaden.',
        translatedTexts: 'De teksten in ',
        images: 'De afbeeldingen',
        translatedAudios: 'De audiotracks in ',
        iconInstruction: 'U kunt de voortgang van het laden van de inhoud volgen door te klikken op het onderstaande pictogram, dat zich naast de menuknop van de toepassing bevindt:',
        end: 'Een melding zal u informeren wanneer de inhoud klaar is met laden. U kunt de toepassing gedurende deze tijd gebruiken.',
        startPreload: 'Download',
        rejectPreload: 'Annuleren',
        close: 'Sluiten'
      },
      preloadStatusText: 'Voorlaadstatus van de inhoud:',
      preloadStatusEnded: 'U kunt de toepassing nu offline gebruiken.',
      off: 'Uit',
      apiDataPreloading: 'Het vooraf laden van teksten...',
      apiDataPreloaded: 'Voorladen van teksten... OK',
      filesPreloading: 'Voorladen van bestanden...',
      filesPreloaded: 'Voorladen van bestanden... OK',
      done: 'Voltooid',
    },
    mediaSync: {
      title: 'Live luisteren',
    }
  },
  es: {
    homePageLoading: 'Cargando página de inicio...',
    dataFrom: 'Los contenidos de la aplicación:',
    available: 'están disponibles solo en el siguiente sitio: ',
    needGeolocation: 'Para acceder a la aplicación, debe estar geolocalizado.',
    enableGeolocation: 'Activar geolocalización',
    thankToAccept: 'Por favor, acepte la solicitud de autorización realizada por su navegador para que esta aplicación pueda acceder a sus datos GPS',
    locationLoading: 'Localización en curso...',
    geolocationDisabled: 'Hmm... La geolocalización no parece estar permitida por su navegador.',
    authorizedBlockGeolocation: 'Por favor, modifique los derechos de acceso a los datos de geolocalización para la aplicación en este navegador.',
    wrongLocation: 'No tiene acceso fuera del sitio.',
    geolocationNotAvailable: 'Su navegador no admite la geolocalización',
    enterTiketNumber: 'Número de billete de la audioguía',
    validate: 'Validar mi billete',
    buyTicket: 'Comprar un billete',
    ticketAvailableOn: 'Fecha de caducidad : ',
    lockText: 'Para acceder a este contenido se necesita un billete de audioguía',
    unLock: 'Desbloquear',
    ticketStatus: {
      tooEarly: 'Su billete aún no es válido',
      tooLate: 'Su billete ya no es válido',
      alreadyUsedByAnother: 'Este billete se está utilizando en otro dispositivo',
      alreadyUsedByMany: 'Se ha alcanzado el número máximo de usos de este billete para su grupo',
      none: 'No tiene ninguna entrada registrada',
      pending: 'Solicitud de validación pendiente',
      notExist: 'Este billete no existe',
      invalidDate: 'Su billete no es válido actualmente',
      alreadyUsed: 'Su billete ya está utilizado',
      valid: 'Su billete es válido',
      error: 'Se ha producido un error en este mensaje'
    },
    content: {
      textContent: {
        readMore: 'Leer más'
      },
      person: {
        readBiography: 'Leer biografía'
      }
    },
    language: {
      selectedLanguage: 'Idioma',
      selectedTarget: 'Especialización / Modo de lectura',
      standard: 'Estándar',
      childMode: 'Nivel infantil',
      signLanguage: 'Lenguaje de signos'
    },
    accessibility: {
      title: 'Accesibilidad',
      textSize: 'Tamaño del texto',
      wordSpacing: 'Espacio entre palabras',
      greyScale: 'Escala de grises',
      dyslexicFont: 'Fuente disléxica',
      highContrast: 'Contraste alto',
      textToSpeech: 'Texto a voz',
    },
    configuration: {
      welcome: '👋 Bienvenido',
      selectedLanguage: 'Idioma seleccionado',
      selectedTarget: 'Modo de lectura',
      start: 'Inicio',
      standard: 'Estándar',
      childMode: 'Nivel infantil',
      signLanguage: 'Lenguaje de signos',
      skip: 'Saltar',
      next: 'Siguiente',
      title: 'Configuración',
      subtitle: 'Para tener la mejor experiencia posible:',
      languageStep: '1️⃣ Selecciona tu idioma',
      accessibilityStep: '2️⃣ Ajusta la accesibilidad',
      congratulation: '👍 ¡Felicitaciones!',
      congratulationText: 'Tu visita está lista.<br><br>Modifica tus preferencias en cualquier momento en la configuración de la aplicación.',
      congratulationEnd: '¡Disfruta tu visita!',
    },
    preloadStatus: {
      reloadTitle: 'Actualizar',
      reloadText: 'La aplicación necesita actualizarse para habilitar ciertas funciones.',
      reloadQuestion: '¿Desea actualizar la aplicación ahora?',
      yes: 'Sí',
      no: 'No',
      preloadModalTitle: 'Descargando contenido',
      preloadModalText: {
        introduction: 'Antes de comenzar el recorrido, debemos descargar los siguientes contenidos:',
        downloading: 'Descarga en curso...',
        downloaded: '¡Felicitaciones, los contenidos están descargados!',
        error: 'Ocurrió un error durante la descarga.',
        translatedTexts: 'Los textos en ',
        images: 'Las imágenes',
        translatedAudios: 'Las pistas de audio en ',
        iconInstruction: 'Puede seguir el progreso de la carga del contenido haciendo clic en el icono de abajo, situado junto al botón de menú de la aplicación:',
        end: 'Una notificación le informará cuando el contenido haya terminado de cargarse. Puede utilizar la aplicación durante este tiempo.',
        startPreload: 'Descargar',
        rejectPreload: 'Cancelar',
        close: 'Cerrar'
      },
      preloadStatusText: 'Estado de precarga de los contenidos:',
      preloadStatusEnded: 'Ya puede utilizar la aplicación sin conexión.',
      off: 'Desactivado',
      apiDataPreloading: 'Precarga de textos...',
      apiDataPreloaded: 'Precarga de textos... OK',
      filesPreloading: 'Precarga de archivos...',
      filesPreloaded: 'Precarga de archivos... OK',
      done: 'Completado'
    },
    mediaSync: {
      title: 'Escuchando en directo'
    }
  },
  it: {
    homePageLoading: 'Caricamento della home page...',
    dataFrom: 'I contenuti dell\'applicazione:',
    available: 'sono disponibili solo sul seguente sito: ',
    needGeolocation: 'Per accedere all\'applicazione, devi essere geolocalizzato.',
    enableGeolocation: 'Attiva geolocalizzazione',
    thankToAccept: 'Accetta la richiesta di autorizzazione fatta dal tuo browser in modo che questa applicazione possa accedere ai tuoi dati GPS',
    locationLoading: 'Localizzazione in corso...',
    geolocationDisabled: 'Hmm... La geolocalizzazione non sembra essere consentita dal tuo browser.',
    authorizedBlockGeolocation: 'Modifica i diritti di accesso ai dati di geolocalizzazione per l\'applicazione su questo browser.',
    wrongLocation: 'Non hai accesso fuori sede.',
    geolocationNotAvailable: 'Il tuo browser non supporta la geolocalizzazione',
    enterTiketNumber: 'Numero del biglietto dell\'audioguida',
    validate: 'Convalidare il mio biglietto',
    buyTicket: 'Comprare un biglietto',
    ticketAvailableOn: 'Data di scadenza: ',
    lockText: 'Per accedere a questo contenuto è necessario un biglietto dell\'audioguida',
    unLock: 'Sblocca',
    ticketStatus: {
      tooEarly: 'Il suo biglietto non è ancora valido',
      tooLate: 'Il tuo biglietto non è più valido',
      alreadyUsedByAnother: 'Questo biglietto è utilizzato su un altro dispositivo',
      alreadyUsedByMany: 'Il numero massimo di usi di questo biglietto per il tuo gruppo è stato raggiunto',
      none: 'Non hai nessun biglietto registrato',
      pending: 'Richiesta di convalida in sospeso',
      notExist: 'Questo biglietto non esiste',
      invalidDate: 'Il suo biglietto non è attualmente valido',
      alreadyUsed: 'Il tuo biglietto è già usato',
      valid: 'Il tuo biglietto è valido',
      error: 'Si è verificato un errore con questo post'
    },
    content: {
      textContent: {
        readMore: 'Leggi di più'
      },
      person: {
        readBiography: 'Leggi la biografia'
      }
    }
  },
  language: {
    selectedLanguage: 'Lingua',
    selectedTarget: 'Specializzazione / Modalità di lettura',
    standard: 'Standard',
    childMode: 'Livello bambino',
    signLanguage: 'Lingua dei segni'
  },
  accessibility: {
    title: 'Accessibilità',
    textSize: 'Dimensione del testo',
    wordSpacing: 'Spaziatura tra le parole',
    greyScale: 'Scala di grigi',
    dyslexicFont: 'Carattere dislessico',
    highContrast: 'Alto contrasto',
    textToSpeech: 'Text to Speech',
  },
  configuration: {
    welcome: '👋 Benvenuto',
    selectedLanguage: 'Lingua selezionata',
    selectedTarget: 'Modalità di lettura',
    start: 'Inizio',
    standard: 'Standard',
    childMode: 'Livello bambino',
    signLanguage: 'Lingua dei segni',
    skip: 'Salta',
    next: 'Avanti',
    title: 'Configurazione',
    subtitle: 'Per avere la migliore esperienza possibile:',
    languageStep: '1️⃣ Seleziona la tua lingua',
    accessibilityStep: '2️⃣ Regola l\'accessibilità',
    congratulation: '👍 Congratulazioni!',
    congratulationText: 'La tua visita è pronta.<br><br>Modifica le tue preferenze in qualsiasi momento nelle impostazioni dell\'applicazione.',
    congratulationEnd: 'Buona visita!',
  },
  preloadStatus: {
    reloadTitle: 'Aggiorna',
    reloadText: 'L\'applicazione deve essere aggiornata per abilitare alcune funzionalità.',
    reloadQuestion: 'Accetti di aggiornare l\'applicazione ora?',
    yes: 'Sì',
    no: 'No',
    preloadModalTitle: 'Download dei contenuti',
    preloadModalText: {
      introduction: 'Prima di iniziare il tour, dobbiamo scaricare i seguenti contenuti:',
      downloading: 'Download in corso...',
      downloaded: 'Congratulazioni, i contenuti sono stati scaricati!',
      error: 'Si è verificato un errore durante il download.',
      translatedTexts: 'I testi in ',
      images: 'Le immagini',
      translatedAudios: 'Le tracce audio in ',
      iconInstruction: 'È possibile seguire l\'avanzamento del caricamento dei contenuti facendo clic sull\'icona sottostante, situata accanto al pulsante del menu dell\'applicazione:',
      end: 'Una notifica vi informerà quando il caricamento del contenuto sarà terminato. Durante questo periodo è possibile utilizzare l\'applicazione',
      startPreload: 'Scarica',
      rejectPreload: 'Annulla',
      close: 'Chiudi'
    },
    preloadStatusText: 'Stato di precaricamento dei contenuti:',
    preloadStatusEnded: 'Ora è possibile utilizzare l\'applicazione offline.',
    off: 'Off',
    apiDataPreloading: 'Precaricamento dei testi...',
    apiDataPreloaded: 'Precaricamento dei testi... OK',
    filesPreloading: 'Precarico dei file...',
    filesPreloaded: 'Precarico dei file... OK',
    done: 'Completato'
  },
  mediaSync: {
    title: 'Ascolto in diretta'
  }
}
